/**
 * Do not edit directly
 * Generated on Wed, 04 Nov 2026 03:58:48 GMT
 */

export const xs = "4px";
export const sm = "8px";
export const md = "16px";
export const lg = "32px";
export const xl = "64px";
